import { useUser } from "@components/user-context";

import { useUpdateUserFeatureFlag } from "./http";

export function useForceOnboarding() {
  const [updateUserFeatureFlag] = useUpdateUserFeatureFlag();

  return {
    setIsForceOnboarding: async (isForceOnboarding: boolean) => {
      await updateUserFeatureFlag(
        "customerOnboardingFinished",
        !isForceOnboarding,
      );
    },
  };
}

export function useInOnboarding() {
  const { user } = useUser();

  return {
    inOnboarding:
      !user.featureFlags["customerOnboardingFinished"] || !!user.deactivatedAt,
  };
}
